import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentUpdate } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { selectorQueryKeys } from "@/query/selector";
import { intentQueryKeys } from "./keys";


export const useUpdateIntent = (agentId: number, skillId?: number, intentId?: string) => {
    const queryClient = useQueryClient();

    return useMutation<Intent, AxiosError, IntentUpdate>({
        mutationKey: ["intent", "agent", agentId, "skill", skillId, "intent", intentId, "update"],
        mutationFn: async (body: IntentUpdate) => {
            try {
                const { data } = await intentRepository.update(agentId, skillId!, intentId!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.names(agentId),
                refetchType: "all"
            });
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                refetchType: "all"
            });
        }
    });
};
